<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h3 class="text-h4" data-aos="fade-right" data-aos-anchor-placement="bottom-bottom" v-html="data.title"></h3>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <v-row>
                    <v-col 
                        cols="12" 
                        data-aos="fade-left"
                        data-aos-anchor-placement="bottom-bottom"
                        md="5" 
                        class="py-5" 
                        v-for="detail in data.details" :key="detail.label">
                        <h4>{{ detail.label }}</h4>
                        <h4 class="text-primary text-h3">
                            {{ detail.value }}
                            <small class="text-h6">{{ detail.unit_measure }}</small>
                        </h4>
                        <v-progress-linear height="1" color="primary" model-value="100"></v-progress-linear>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>